<template>
  <div>
    <Header />
    <div style="padding-left: 30px; padding-right: 30px; padding-bottom: 80px">
      <center v-if="loading">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <br />
      <el-row v-if="!loading" :gutter="20">
        <el-col :md="12">
          <h2>{{ $t("CREACIÓN DE CONTRATO - PASO 3") }}</h2>
        </el-col>
        <el-col :md="12">
          <StepsContrato v-bind:step="2"></StepsContrato>
        </el-col>
      </el-row>
      <div v-if="!loading">
        <el-form :model="contractPeople" label-position="top">
          <el-row
            :gutter="20"
            v-if="newContract.tipo_contrato === 'Contratista'"
          >
            <el-col :sm="24">
              <h3>{{ $t("Asignación de revisores") }}</h3>
            </el-col>
            <el-col :sm="24">
              <!-- Personas contratista -->
              <h4>Personas Contratistas</h4>
            </el-col>
            <!-- Coordinador Contratista-->
            <el-col :md="12" v-if="newContract.tipo_contrato === 'Contratista'">
              <el-form-item :label="$t('Coordinador Contratista')">
                <PeopleSelect
                  :model.sync="contractPeople.contractor_coordinator[0]"
                  :users="
                    companyUsersWithRole(
                      'contractor_coordinator',
                      'Contratista'
                    )
                  "
                />
              </el-form-item>
            </el-col>

            <el-col :md="12">
              <el-form-item :label="$t('HSE Contratista 1')">
                <PeopleSelect
                  :model.sync="contractPeople.contractor_hse[0]"
                  :users="companyUsersWithRole('contractor_hse', 'Contratista')"
                />
              </el-form-item>
            </el-col>

            <el-col :md="12">
              <el-form-item :label="$t('HSE Contratista 2')">
                <PeopleSelect
                  :model.sync="contractPeople.contractor_hse[1]"
                  :users="companyUsersWithRole('contractor_hse', 'Contratista')"
                />
              </el-form-item>
            </el-col>

            <el-col :md="12">
              <el-form-item :label="$t('Administrador de Contrato')">
                <PeopleSelect
                  :model.sync="contractPeople.administrator[0]"
                  :users="companyUsersWithRole('administrator', 'Contratista')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- Personas BHP -->
          <h4>Personas de la Compañia</h4>
          <el-row :gutter="20">
            <el-col :md="24" v-if="newContract.tipo_contrato === 'Propio'">
              <el-form-item :label="$t('Coordinador')">
                <PeopleSelect
                  :model.sync="contractPeople.coordinator[0]"
                  :users="bhpUsersWithRole('coordinator')"
                />
              </el-form-item>
            </el-col>

            <!-- Salud -->
            <el-col :md="12">
              <el-form-item :label="$t('Especialista Salud 1')">
                <PeopleSelect
                  :model.sync="contractPeople.health[0]"
                  :users="bhpUsersWithRole('health')"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item :label="$t('Especialista Salud 2')">
                <PeopleSelect
                  :model.sync="contractPeople.health[1]"
                  :users="bhpUsersWithRole('health')"
                />
              </el-form-item>
            </el-col>
            <!-- Seguridad -->
            <el-col :md="12">
              <el-form-item :label="$t('Especialista Seguridad 1')">
                <PeopleSelect
                  :model.sync="contractPeople.safety[0]"
                  :users="bhpUsersWithRole('safety')"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item :label="$t('Especialista Seguridad 2')">
                <PeopleSelect
                  :model.sync="contractPeople.safety[1]"
                  :users="bhpUsersWithRole('safety')"
                />
              </el-form-item>
            </el-col>
            <!-- Medioambiente -->
            <el-col :md="12">
              <el-form-item :label="$t('Especialista Medioambiente 1')">
                <PeopleSelect
                  :model.sync="contractPeople.environment[0]"
                  :users="bhpUsersWithRole('environment')"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item :label="$t('Especialista Medioambiente 2')">
                <PeopleSelect
                  :model.sync="contractPeople.environment[1]"
                  :users="bhpUsersWithRole('environment')"
                />
              </el-form-item>
            </el-col>

            <el-col
              :md="12"
              v-if="
                newContract.tipo_contrato === 'Contratista' ||
                newContract.tipo_contrato === 'Subcontratista'
              "
            >
              <el-form-item :label="$t('Dueño de Contrato')">
                <PeopleSelect
                  :model.sync="contractPeople.owner[0]"
                  :users="bhpUsersWithRole('owner')"
                />
              </el-form-item>
            </el-col>

            <el-col :md="12">
              <el-form-item :label="$t('Especialista de Riesgo')">
                <PeopleSelect
                  :model.sync="contractPeople.risk[0]"
                  :users="bhpUsersWithRole('risk')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <h4>
          {{ $t("Perfiles relacionados al área") }}
          "{{ this.area.nombre }}"
          <span v-if="this.area.area_padre"
            >, {{ $t("perteneciente a área") }} "{{
              this.area.area_padre.nombre
            }}"</span
          >
        </h4>
        <el-row :gutter="20">
          <el-col :md="8">
            <div class="titleProfilesArea">{{ $t("Superintendente") }}</div>
            <div class="textProfilesArea">{{ areaSuperintendent }}</div>
          </el-col>
          <el-col :md="8">
            <div class="titleProfilesArea">{{ $t("Gerente") }}</div>
            <div class="textProfilesArea">{{ areaManager }}</div>
          </el-col>
          <!-- <el-col :md="8">
            <div class="titleProfilesArea">{{ $t("Gerente General") }}</div>
            <div class="textProfilesArea">{{ areaSuperiorManager }}</div>
          </el-col> -->
        </el-row>
      </div>
      <br />
      <br />
      <br />
      <el-col :span="24" class="centrar">
        <el-button-group>
          <el-button
            type="primary"
            @click="backStep()"
            icon="el-icon-arrow-left"
            >Regresar</el-button
          >
          <el-button :loading="isLoading" @click="nextStep()" type="primary">
            {{ $t("Finalizar") }}
            <i class="el-icon-arrow-right el-icon-right"></i>
          </el-button>
        </el-button-group>
      </el-col>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import { Circle9 } from "vue-loading-spinner";
import axios from "axios";
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import StepsContrato from "@/components/contracts/StepsContrato.vue";
import PeopleSelect from "@/components/contracts/PeopleSelect.vue";

export default {
  name: "wizard",
  components: {
    Header,
    StepsContrato,
    PeopleSelect,
    Circle9,
  },
  data() {
    return {
      loading: false,
      isLoading: false,
      contractPeople: {
        contractor_coordinator: [""],
        contractor_hse: ["", ""],
        administrator: [""],
        coordinator: [""],
        owner: [""],
        risk: [""],
        hse: ["", ""],
        health: ["", ""],
        safety: ["", ""],
        environment: ["", ""],
      },
      bhpProfiles: {
        hse: "HSE",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("HSE Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente"),
        super: this.$t("Superintendente"),
        general_manager: this.$t("Gerente General"),
      },
      areas: [],
      usersFaena: [],
    };
  },
  async created() {
    if (Object.keys(this.$store.getters.newContract).length === 0) {
      this.$router.push({ name: "autoCreacionStep1" });
    } else {
      await this.getUsersFaena(this.newContract.faena_id);
      await this.getAreas(this.newContract.faena_id);
    }
  },
  computed: {
    ...mapGetters({
      newContract: "newContract",
    }),
    area() {
      var area = this.areas.find(
        (area) => area._id === this.newContract.area_id
      );
      if (area) {
        return area;
      } else {
        return {};
      }
    },
    areaSuperintendent() {
      let user = this.usersFaena.find((x) => x._id === this.area.super_id);
      if (user) {
        return `${user.nombre} ${user.apellido}`;
      } else {
        return "---";
      }
    },
    areaManager() {
      let user = this.usersFaena.find((x) => x._id === this.area.manager_id);
      if (user) {
        return `${user.nombre} ${user.apellido}`;
      } else {
        return "---";
      }
    },
    areaSuperiorManager() {
      if (!this.area.area_padre_id) {
        return "---";
      } else {
        var area = this.areas.find(
          (area) => area._id === this.area.area_padre_id
        );
        if (area) {
          let user = this.usersFaena.find((x) => x._id === area.manager_id);
          if (user) {
            return `${user.nombre} ${user.apellido}`;
          } else {
            return "---";
          }
        } else {
          return "---";
        }
      }
    },
  },
  methods: {
    ...mapActions(["setNewContract", "saveContractAutoCreation", "resetNewContract"]),
    async getUsersFaena(faena_id) {
      this.loading = true;
      let response = await axios.get(`/data-science/usuarios/${faena_id}`);
      this.usersFaena = response.data.usersFaena;
      this.loading = false;
    },
    async getAreas(faena_id) {
      let response = await axios.get(`/data-science/areas/${faena_id}`);
      this.areas = response.data;
    },
    backStep() {
      this.$router.push({ name: "autoCreacionStep2" });
    },
    async nextStep() {
      this.isLoading = true;
      this.loading = true;
      let valid = true;
      valid = this.contractPeopleValidation();
      // Registrar cambios en local si es válido
      if (valid) {
        const auxContract = Object.assign({}, this.newContract, {
          revisores: this.contractPeople,
        });
        this.setNewContract(auxContract);
        const response = await this.saveContractAutoCreation();
        if (response.success) {
          this.loading = false;
          this.resetNewContract();
          this.$router.push({ name: "accountSuccess", params: response.data });
        } else {
          console.log("error al guardar");
          this.loading = false;
        }
      } else {
        this.$message({
          message:
            "Atención, Para continuar debes completar todos los campos requeridos.",
          type: "warning",
        });
        this.loading = false;
      }
    },
    contractPeopleValidation() {
      const nc = this.newContract;
      const cp = this.contractPeople;
      if (
        true &&
        !cp.health.includes("") &&
        !cp.safety.includes("") &&
        !cp.environment.includes("") &&
        !cp.risk.includes("")
      ) {
        if (
          true &&
          nc.tipo_contrato === "Propio" &&
          !cp.coordinator.includes("")
        ) {
          return true;
        }
        if (
          nc.tipo_contrato === "Contratista" ||
          nc.tipo_contrato === "Subcontratista"
        ) {
          if (
            true &&
            !cp.contractor_coordinator.includes("") &&
            !cp.contractor_hse.includes("") &&
            !cp.administrator.includes("") &&
            !cp.owner.includes("")
          ) {
            return true;
          }
        }
      }
      return false;
    },
    bhpUsersWithRole(role) {
      const admins = [];
      const specifics = [];
      const others = [];
      this.usersFaena.forEach((user) => {
        if (user.roles.admin) {
          admins.push(user);
        } else if (
          user.roles.areas &&
          user.roles.areas[this.newContract.area_id] &&
          user.roles.areas[this.newContract.area_id].includes(role)
        ) {
          specifics.push(user);
        } else if (user.roles.areas) {
          for (const key in user.roles.areas) {
            if (user.roles.areas[key].includes(role)) {
              others.push(user);
              break;
            }
          }
        }
      });
      return [
        { label: "Específicos del área", options: specifics },
        { label: "Otras áreas", options: others },
        { label: "Administrador Plataforma", options: admins },
      ];
    },
    companyUsersWithRole(role, tipo) {
      const specifics = [];
      const others = [];
      if (tipo === "Contratista") {
        this.usersFaena.forEach((user) => {
          if (
            user.roles.empresas &&
            user.roles.empresas[this.newContract.empresa_id]
          ) {
            if (
              user.roles.empresas[this.newContract.empresa_id].includes(role)
            ) {
              specifics.push(user);
            } else {
              others.push(user);
            }
          }
        });
      }
      return [
        { label: "Específicos", options: specifics },
        { label: "Otros", options: others },
      ];
    },
  },
};
</script>

<style scoped>
.titleProfilesArea {
  color: #606266;
  font-size: 14px;
}
.textProfilesArea {
  margin-top: 10px;
  color: gray;
  font-size: 14px;
}
.centrar {
  text-align: center;
}
</style>
